"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTransition = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_transition_group_1 = require("react-transition-group");
var noop_1 = require("../_util/noop");
function BaseTransition(_a) {
    var enter = _a.in, _b = _a.onEnter, onEnter = _b === void 0 ? noop_1.noop : _b, _c = _a.onExit, onExit = _c === void 0 ? noop_1.noop : _c, _d = _a.onExited, onExited = _d === void 0 ? noop_1.noop : _d, children = _a.children, props = tslib_1.__rest(_a, ["in", "onEnter", "onExit", "onExited", "children"]);
    // 离场时保持 children 不变
    var childrenRef = react_1.useRef(null);
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, tslib_1.__assign({}, props, { in: enter, onEnter: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            childrenRef.current = null;
            onEnter.apply(void 0, tslib_1.__spread(args));
        }, onExit: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            childrenRef.current = children;
            onExit.apply(void 0, tslib_1.__spread(args));
        }, onExited: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            childrenRef.current = null;
            onExited.apply(void 0, tslib_1.__spread(args));
        } }), childrenRef.current || children));
}
exports.BaseTransition = BaseTransition;
BaseTransition.displayName = "BaseTransition";
//# sourceMappingURL=BaseTransition.js.map